import React, { useCallback, useState } from 'react';
import { motion } from 'framer-motion';
import { ProgressIndicator } from './ProgressIndicator';
interface SlideExpectationProps {
  onNext: () => void;
  onAnswer: (answerIndex: number) => void;
}
const options = [{
  label: '~50% reduction',
  value: '~50%'
}, {
  label: '~70–80% reduction',
  value: '~70–80%'
}, {
  label: '≥90% reduction',
  value: '≥90%'
}];
export function SlideExpectation({
  onNext,
  onAnswer
}: SlideExpectationProps) {
  const [selected, setSelected] = useState<number | null>(null);
  const handleSelect = useCallback((index: number) => {
    if (selected !== null) return;
    setSelected(index);
    onAnswer(index);
    setTimeout(() => {
      onNext();
    }, 900);
  }, [selected, onAnswer, onNext]);
  return <div className="relative w-full h-full flex flex-col items-center justify-center px-6" data-id="element-73">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
      backgroundImage: 'linear-gradient(rgba(0,180,216,1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,180,216,1) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-74" />

      <div className="relative z-10 max-w-xl mx-auto w-full flex flex-col items-center" data-id="element-75">
        <motion.div className="w-full" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-76">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 text-center leading-snug mb-10" data-id="element-77">
            In routine clinical practice, what level of attack reduction would
            you expect after <span className="text-teal-600" data-id="element-78">6 months</span> of
            prophylaxis?
          </h2>
        </motion.div>

        <div className="w-full space-y-3" data-id="element-79">
          {options.map((option, index) => {
          const isSelected = selected === index;
          const isOther = selected !== null && selected !== index;
          return <motion.button key={index} onClick={() => handleSelect(index)} disabled={selected !== null} className={`w-full text-left px-6 py-5 rounded-xl border transition-all duration-400 
                  focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-white
                  ${isSelected ? 'border-teal-500 bg-teal-50 text-slate-900 shadow-lg shadow-teal-500/10' : isOther ? 'border-slate-200/50 bg-slate-50 text-slate-400' : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50'}`} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: isOther ? 0.4 : 1,
            x: 0,
            scale: isSelected ? 1.02 : isOther ? 0.98 : 1
          }} transition={{
            duration: 0.4,
            delay: 0.2 + index * 0.1
          }} whileHover={selected === null ? {
            scale: 1.01
          } : {}} whileTap={selected === null ? {
            scale: 0.99
          } : {}} aria-pressed={isSelected} data-id="element-80">
                <div className="flex items-center gap-4" data-id="element-81">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all duration-300 ${isSelected ? 'border-teal-500 bg-teal-500' : 'border-slate-300'}`} data-id="element-82">
                    {isSelected && <motion.div className="w-2 h-2 rounded-full bg-white" initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  duration: 0.2
                }} data-id="element-83" />}
                  </div>
                  <div className="flex items-center gap-3" data-id="element-84">
                    <span className={`text-2xl sm:text-3xl font-bold tabular-nums ${isSelected ? 'text-teal-600' : 'text-teal-600/80'}`} data-id="element-85">
                      {option.value}
                    </span>
                    <span className="text-base sm:text-lg font-medium text-slate-500" data-id="element-86">
                      reduction
                    </span>
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        <motion.div className="mt-12" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} data-id="element-87">
          <ProgressIndicator currentStep={4} totalSteps={7} data-id="element-88" />
        </motion.div>
      </div>
    </div>;
}